module.exports = __webpack_public_path__ + "img/avatar.4b40af12.png";